export default "__VITE_ASSET__af8c6f40__"